// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/heart.js';

import { paths } from '../generated/heart';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('heart', Original, paths);
